module.exports = __webpack_public_path__ + "media/images/happy_phone_guy-62d9ff98f8b810d4cb3d5477298e650a.svg";